import React from 'react';
import {ScrollView, StyleSheet, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Footprint,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import ArrangedIcons from '../ArrangedIcons';

const storyStyle = StyleSheet.create({
  footprint: {
    width: '100%',
  },
});

storiesOf('partial', module).add('ArrangedIcons', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView expand={true}>
        <Heading level={1}>Arranged Icons</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>ArrangedIcons</Code> component is used to render a
          horizontally arrangement of icons.
        </Text>
        <Spacer size={16} />
        <Footprint style={storyStyle.footprint}>
          <ArrangedIcons
            // @ts-expect-error TS(2322): Type '{ leftIcons: string[]; rightIcons: string[];... Remove this comment to see the full error message
            leftIcons={['menu', 'dashboard', 'team']}
            rightIcons={['clients', 'search']}
          />
        </Footprint>
        <Spacer size={16} />
        <Text>
          The icons displayed can be customized by passing in namne of icons as
          values for the <Code>leftIcons</Code> and <Code>rightIcons</Code>{' '}
          props.
        </Text>
        <Spacer size={6} />
        <Code>{'<ArrangedIcons'}</Code>
        <Code>{"  leftIcons={['menu', 'dashboard', 'team']}"}</Code>
        <Code>{"  rightIcons={['clients', 'search']}"}</Code>
        <Code>{'/>'}</Code>
        <Spacer size={16} />
        <Text>
          The <Code>onIconPress</Code> props accepts a function that would be
          called with the name of icon when clicked.
        </Text>
        <Spacer size={6} />
        <Code>{'<ArrangedIcons'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'  onIconPress={(iconName) => {...}}'}</Code>
        <Code>{'/>'}</Code>
        <Spacer size={16} />
        <Text>
          We can also pass some object that will be displayed in the center
        </Text>
        <Spacer size={16} />
        <Footprint style={storyStyle.footprint}>
          <ArrangedIcons leftIcons={['menu']} rightIcons={['clients']}>
            <Text>Some title</Text>
          </ArrangedIcons>
        </Footprint>
        <Spacer size={16} />
        <Code>{'<ArrangedIcons'}</Code>
        <Code>{"  leftIcons={['menu']}"}</Code>
        <Code>{"  rightIcons={['clients']}"}</Code>
        <Code>{'>'}</Code>
        <Code>{'  <Text>Some title</Text>'}</Code>
        <Code>{'</ArrangedIcons>'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
